import React, { useEffect, useState } from 'react';

type Req = (path: string, body?: any, signal?: AbortSignal) => Promise<any>;
const P = '/api/rolling/simple-bsp/punter-stake';
const pct = (n: number) => (Math.round(n * 1000) / 10).toFixed(1) + '%';
const money = (n: number) => '$' + Math.round(n || 0).toLocaleString('en-AU');

// Owner 2026-10-25: the Punter's daily staking. Default = the drawdown schedule's % of bank; the owner can raise or lower it.
const PunterStakeToggle: React.FC<{ request: Req }> = ({ request }) => {
  const [d, setD] = useState<any>(null);
  const [draft, setDraft] = useState(1);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const apply = (x: any) => { setD(x); setDraft(Number(x.scale) || 1); };
  useEffect(() => {
    const ac = new AbortController();
    request(P, undefined, ac.signal).then(apply).catch((e: any) => { if (!ac.signal.aborted) setError(e.message); });
    return () => ac.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function save(scale: number) {
    if (!d || scale === d.scale) return;
    if (scale > d.scale && !window.confirm(`Raise the Punter's daily staking to ${pct(d.default_pct * scale)} of the bank? About ${money(d.effective_per_bet / d.scale * scale)} per bet today.`)) return;
    setBusy(true); setError('');
    try { apply(await request(P, { scale })); } catch (e: any) { setError(e.message); } finally { setBusy(false); }
  }
  if (!d) return <div className="punter-stake-toggle"><strong>Punter staking</strong> {error ? <span role="alert">{error}</span> : '...'}</div>;
  const perBet = d.effective_per_bet / (d.scale || 1) * draft;
  return (
    <div className="punter-stake-toggle" role="group" aria-label="Punter staking" style={{ margin: '10px 0' }}>
      <strong>Punter staking (my system bets)</strong>{' '}
      <span>Default {pct(d.default_pct)} of the {money(d.bank)} bank per day (≈ {money(d.default_per_bet)} a bet) · Now <strong>{pct(d.effective_pct)}</strong>{d.scale !== 1 ? ` (${d.scale}× default)` : ' (default)'}</span>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, margin: '6px 0' }}>
        <input type="range" min={d.scale_min} max={d.scale_max} step={0.05} value={draft} disabled={busy}
          aria-label="Punter daily staking" onChange={e => setDraft(Math.round(Number(e.target.value) * 20) / 20)} />
        <output style={{ minWidth: 60, fontWeight: 600 }}>{pct(d.default_pct * draft)}</output>
        <small>≈ {money(perBet)} a bet across {d.n_bets} bets</small>
        <button type="button" disabled={busy || draft === d.scale} onClick={() => save(draft)}>{draft === d.scale ? 'Saved' : `Apply ${pct(d.default_pct * draft)}`}</button>
        <button type="button" disabled={busy || d.scale === 1} onClick={() => save(1)}>Reset to default</button>
      </div>
      <small>The default follows your drawdown schedule, so the % falls as the bank grows; your setting scales it ({d.scale_min}×–{d.scale_max}× default). A change re-sizes today's bets not yet locked; locked and submitted bets keep their stake. Minimum bet $10.</small>
      {error && <span role="alert"> {error}</span>}
    </div>
  );
};
export default PunterStakeToggle;
